export const contactData = [
    {
        id: 1,
        name: 'Redwan Newaz, Ph.D. (PI)',
        position: 'Assistant Professor, Director of the AiR Lab',
        email: 'aredwann@lsuneworleans.edu',
        logo: 'redwan.jpg',
    },
    {
        id: 2,
        name: 'Sourav Raxit',
        position: 'Graduate Researcher (Ph.D.)',
        phone: '',
        email: 'sraxit@my.lsuneworleans.edu',
        logo: 'sourav.png'
    },
    {
        id: 3,
        name: 'Simant Bahadur Singh',
        position: 'Graduate Researcher (M.S.)',
        phone: '',
        email: 'sbsingh3@my.lsuneworleans.edu',
        logo: 'simant.png'
    },
    {
        id: 4,
        name: 'MD Muhtasim Daiyan Rahman',
        position: 'Undergraduate Researcher (B.S.)',
        phone: '',
        email: 'mrahma12@my.lsuneworleans.edu',
        logo: 'profile.png'
    }
]
